/**
 * A minimal implementation of getting
 * a value from an object using path
 */

export const dotGet = (obj, path) =>
  path?.split('.')?.reduce((acc, key) => {
    return acc?.[key];
  }, obj);
